module.exports = __webpack_public_path__ + "static/media/m8cr93.1e9712fc.png";